import { create } from 'apisauce';

export const getSchedulerInfo = async (email, redirect_uri) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/integrations/get-scheduler-info`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  return api.get('', { 'login_hint': email, 'redirect_uri': redirect_uri });
};

export const getSchedulerConfigs = async () => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/integrations/get-configs`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  return api.get();
};

export const schedulerProxy = async (body) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/integrations/scheduler-proxy`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  return api.post('', body);
};
